<th scope="row" class="border-bold-left border-bold-right" [innerHTML]="caption | translate"></th>
@if (rowData) {
  @for (key of keys; track key; let last = $last) {
    <td class="text-align-right" [ngClass]="{'shaded': last}">{{ rowData[key]?.koeffizient | numberFormat: crtLocale:5 }}</td>
    <td class="text-align-left" [ngClass]="{'shaded': last}">{{ rowData[key]?.signifikanz }}</td>
    <td class="text-align-right border-bold-right" [ngClass]="{'shaded': last}">{{ rowData[key]?.standardFehler | numberFormat: crtLocale:5 }}</td>
  }
}
